import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { IDivisionTable, ITarget } from '../../types/interfaces';

import DivisionAnswer from './DivisionAnswer';
import BienCard from '../bien_card/BienCardInfo';
import TableContainer from "../tables_manager/TableContainer"
import { SelectColumnFilter, NumberRangeColumnFilter } from '../tables_manager/filters';
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faCheckCircle, faExternalLinkAlt, faEye, faPen, faQuestionCircle, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import LinesEllipsis from 'react-lines-ellipsis'
import ReactTooltip from 'react-tooltip';

const DivisionTable = ({ 
  linesData,
 }: IDivisionTable) => {
  const [selectedValue, setSelectedValue] = useState('');
  const skipResetRef = React.useRef(false);
  const [modal, setModal] = useState(false);
  const [modalDivision, setModalDivision] = useState('');
  const [modalBien, setModalBien] = useState(false);
  const [modalBienBien, setModalBienBien] = useState('');
  const [answer, setAnswer] = useState(-1);
  const history = useHistory();

  const alert = useAlert();
  
  const handleSelectChange = data => {
    setSelectedValue(data ? data.value : '');
  }
  
  const handleToggle = () => setModal(!modal);
  const handleToggleBien = () => setModalBien(!modalBien);

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        hidden: true
      },
      {
        Header: "Bien",
        accessor: e => e.bien?.DESIGNATION || "",
        Cell: ({ value, row: {original} }) => {
          return (<div className="fullFlexCenter">
            {original.bien?.DESIGNATION || original.bien_id}
            &nbsp;<FontAwesomeIcon icon={faEye} style={{cursor: "pointer"}} onClick={() => {
              if(original.bien?.contrat)
                window.open('/consultation/' + original.bien.contrat.id,'_blank')
              else{
                setModalBien(true);
                setModalBienBien(original.bien);
              }
            }} />
          </div>)
        }
        // Cell: ({ value, row: {original} }) => {
        //   return (<><a href={value !== null && value !== undefined ? (`/fiche_bien/${value}`) : '/#'} onClick={(e) => {
        //     e.preventDefault();
        //     if(value !== null && value !== undefined){
        //       if (e.ctrlKey){
        //         window.open('/fiche_bien/' + value,'_blank');
        //         return;
        //       }
        //       history.push({ pathname: `/fiche_bien/${value}` })
        //     }
        //     else
        //       alert.error(E_ERROR.NO_BIEN_WITH_THIS_ID)
        //   }}><button className="openLinkBtn">{original.bien?.DESIGNATION || value}<FontAwesomeIcon icon={faExternalLinkAlt} className="openLinkIcon" /></button></a>
        //     &nbsp;<FontAwesomeIcon icon={faEye} style={{cursor: "pointer"}} onClick={() => {
        //       setModalBien(true);
        //       setModalBienBien(original.bien);
        //     }} />
        //   </>)
        // }
      },
      {
        Header: "N°",
        accessor: e => e.bien?.N || "",
        Cell: ({ value }) => value || "-"
      },
      // {
      //   Header: "Type",
      //   accessor: "TYPE_2",
      //   customExportDisplay: `$.bien && $.bien.TYPE ? $.bien.TYPE : "-"`,
      //   // Filter: (e) => SelectColumnFilter({...e, capitalizeFirst: true}),
      //   // filter: 'equals',
      //   Cell: ({ row: {original} }) => original.bien?.TYPE || "-"
      // },
      {
        Header: "Tranche",
        accessor: e => e.bien?.TRANCHE || "",
        // Filter: SelectColumnFilter,
        // filter: 'equals',
        Cell: ({ value }) => value || "-"
      },
      // {
      //   Header: "Immeuble",
      //   accessor: "IMMEUBLE",
      //   Cell: ({ row: {original} }) => (!original.bien || (!original.bien?.IMMEUBLE && original.bien?.IMMEUBLE !== "0")) ? "-" : original.bien?.IMMEUBLE
      // },
      {
        Header: "Demandée par",
        accessor: e => e.divisionUserCreated?.LOGIN || "",
      },
      {
        Header: "Saisie le",
        accessor: "createdAt",
        customExportDisplay: `$.createdAt ? new Date($.createdAt) : ""`,
        filter: (rows, id, e) => rows.filter(t => t.original[id] && moment(t.original[id]).format('DD/MM/YYYY').includes(e)),
        Cell: ({ value }) => value ? <div title={moment(value).format('DD/MM/YYYY - HH:mm')}>{moment(value).locale('fr').calendar({
            sameDay: '[Aujourd\'hui à] HH:mm',
            nextDay: 'DD/MM/YYYY à HH:mm',
            nextWeek: 'DD/MM/YYYY à HH:mm',
            lastDay: '[Hier à] HH:mm',
            lastWeek: 'DD/MM/YYYY à HH:mm',
            sameElse: 'DD/MM/YYYY à HH:mm'
        })}</div> : "-"
      },
      {
        Header: "Commentaire",
        accessor: "comment",
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "Action",
        className: "text-center",
        Cell: ({ row }) => (
            <Container className="actionsContainer">
                {row.original.approved !== 1 ? <button className="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light"
                  onClick={() => {setAnswer(1); setModalDivision(row.original); setModal(true)}}
                  title="Accepter">
                  <FontAwesomeIcon icon={faCheck} />
                </button> : null}
                {row.original.approved !== 1 ? <button className="btn btn-danger btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                  onClick={() => {setAnswer(0); setModalDivision(row.original); setModal(true)}}
                  title="Refuser">
                  <FontAwesomeIcon icon={faTimes} />
                </button> : null}
            </Container>
        ),
        disableSortBy: true,
     }
    ],
    []
  );
  
  return (
    <div>
      <Container>
        <TableContainer columns={columns} data={linesData} enableCheckBox={false} isEditable={false} SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>
      </Container>
      <DivisionAnswer modal={modal} setModal={setModal} handleToggle={handleToggle} modalData={modalDivision} answer={answer} />
      <Modal isOpen={modalBien} toggle={handleToggleBien} className="modal-dialog-large">
        <ModalHeader toggle={handleToggleBien}>Détails du Bien</ModalHeader>
        <ModalBody>
          {modalBienBien && <BienCard selectedBien={modalBienBien} />}
        </ModalBody>
      </Modal>
    </div>
  );
};

export default connect(null, {})(DivisionTable);
